import { ref } from 'vue'
import { DeviceIds } from '@libs/define/device_registry'

export type KK = number
export type VK = number
export type LK = number
export type EffectIndex = number
export const kks = ref<{ [index: KK]: VK }>({})

export type DevicePid = number
export const DevicePid = DeviceIds as { [K in keyof typeof DeviceIds]: DevicePid }

export const EEvisionDeviceList = new Map()
EEvisionDeviceList.set(0x0c457638, 'IK6-M')
EEvisionDeviceList.set(0x320f504e, 'Fe87')
EEvisionDeviceList.set(0x320f5051, 'Fe104')
EEvisionDeviceList.set(0x320f505d, 'Fe87 RGB')
EEvisionDeviceList.set(0x320f505e, 'Fe104 RGB')
EEvisionDeviceList.set(0x320f5083, 'AL87')
EEvisionDeviceList.set(0x320f50ad, 'Fe104 Mixed')
EEvisionDeviceList.set(0x320f50ae, 'Fe87 Mixed')

export const getKKByVK = (vk: VK): KK | null => {
  for (const [kk, value] of Object.entries(kks.value)) {
    if (value == vk) {
      return Number(kk) as KK
    }
  }
  return null
}
